import React from 'react';
import { Typography, Box, Grid } from '@material-ui/core';
import moment from 'moment';
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import NewReleasesRoundedIcon from '@material-ui/icons/NewReleasesRounded';
import SpartaLogo from '../../../../assets/img/sparta_logo.png';
import { dateMonthYearDateFormat } from '../config/whatsNewConfig';

const WhatsNewCard = ({ latestArtwork, latestUpdate, sortedUpdatesCount, activeApplicationsCount, onExploreClick }) => {
    
    return (
        <Box className="whats-new-hero">
            <Grid container spacing={4} alignItems="center" className="whats-new-hero-grid">
                <Grid item xs={12} md={7} className="whats-new-hero-left">
                    <Box className="whats-new-hero-badge">
                        {/* <Box className="whats-new-hero-badge-logo">
                            <Box component="img" src={SpartaLogo} alt="SPARTA" className="whats-new-hero-badge-logo-img" />
                        </Box> */}
                        <Typography className="whats-new-hero-badge-text">PRODUCT UPDATES</Typography>
                        <Box className="whats-new-hero-badge-dot" />
                    </Box>
                    <Typography component="h1" className="whats-new-hero-title">
                        What’s new in <Box component="span" className="whats-new-hero-title-accent">SPARTA</Box>
                    </Typography>
                    <Typography className="whats-new-hero-subtitle">
                        Stay informed about the latest capabilities across your aviation asset lifecycle from commercial lease operations and technical records to maintenance, airworthiness and asset transitions.
                    </Typography>
                    <Box className="whats-new-hero-actions">
                        <Box component="button" type="button" onClick={onExploreClick} className="whats-new-hero-btn">
                            <Typography component="span" className="whats-new-hero-btn-label">Explore releases</Typography>
                            <ArrowForwardRoundedIcon />
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={5}>
                    <Box className="whats-new-hero-card">
                        <Box className="whats-new-hero-card-panel">
                            <Box className="whats-new-hero-card-row">
                                <Box className="whats-new-hero-card-icon">
                                    {latestArtwork?.isHome ? (
                                        <HomeRoundedIcon />
                                    ) : latestArtwork?.src ? (
                                        <Box component="img" src={latestArtwork.src} alt={latestArtwork.alt} className="whats-new-hero-card-icon-img" />
                                    ) : (
                                        <NewReleasesRoundedIcon />
                                    )}
                                </Box>
                                <Box className="whats-new-hero-card-meta">
                                    <Typography className="whats-new-hero-card-label">
                                        LATEST RELEASE{latestUpdate?.label ? ` · ${latestUpdate.label}` : ''}
                                    </Typography>
                                    <Typography className="whats-new-hero-card-date">
                                        {latestUpdate ? moment(latestUpdate.release_date).format(dateMonthYearDateFormat) : 'Coming soon'}
                                    </Typography>
                                </Box>
                            </Box>
                            <Typography className="whats-new-hero-card-title">
                                {latestUpdate?.title || 'The next SPARTA improvement is being prepared.'}
                            </Typography>
                        </Box>
                        <Box className="whats-new-hero-stats">
                            <Box className="whats-new-hero-stat">
                                <Typography className="whats-new-hero-stat-value">{sortedUpdatesCount}</Typography>
                                <Typography className="whats-new-hero-stat-label">Published updates</Typography>
                            </Box>
                            <Box className="whats-new-hero-stat">
                                <Typography className="whats-new-hero-stat-value">{activeApplicationsCount}</Typography>
                                <Typography className="whats-new-hero-stat-label">Active applications</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
};

export default WhatsNewCard;